export enum PDxPOStatus {
    Created = 0,
    Approved = 1,
    Transmitted = 2,
    AwaitingEmail = 3,
    AwaitingApproval1 = 4,
    AwaitingApproval2 = 5,
    AwaitingApproval3 = 6,
    AwaitingApproval4 = 7,
    AwaitingApproval5 = 8,
    Rejected = 9,
    PartiallyReceived = 10,
    FullyReceived = 11,
}